import {isUndefined} from 'shared/utils/isUndefined';
import {isNull} from 'shared/utils/isNull';

interface Dependencies {
  stringifier?: StringConstructor;
}

export function str(arg: Stringifiable, di: Dependencies = {}): string {
  if (isUndefined(arg) || isNull(arg)) return '';

  const {stringifier = String} = di;
  return stringifier(arg);
}
